function waitForElement(className, callback) {
  if (document.querySelector(className)) {
    callback();
  } else {
    setTimeout(function() {
      waitForElement(className, callback);
    }, 1000); 
  }
}

waitForElement('.tpo_option-set-wrapper', function() {
    const addOnWrapper = document.querySelector('.tpo_total-additional-price-wrapper');
    const optionSetContainer = document.querySelector('[id*="tpo_option-set-container"]');
    const engravingLine1 = Array.from(optionSetContainer.childNodes).at(-5);
    const og = document.querySelector('.price__container .price__regular');
    const n = og.cloneNode(true);
    let priceAdjusted = false;  // Flag to track price adjustment state

    n.classList.add('duplicated-price');
    og.parentNode.insertBefore(n, og.nextSibling);
    og.style.display = 'none';
    addOnWrapper.style.display='none';

    if (engravingLine1) {
        const engravingInput = engravingLine1.querySelector('.tpo_option-input-wrapper .tpo_text-box');
        let p = Array.from(n.childNodes).at(-1);
        p.classList.remove('tpo_product_price');

        engravingInput.addEventListener("input", (event) => {
            let c = event.target.value;

            if (c.length > 0 && !priceAdjusted) {
                // Update price if input is greater than 1 character
                p.textContent += ' + $35.00';
                priceAdjusted = true;
            } else if (c.length === 0){
                // Remove price adjustment if input has 1 character or less
                p.textContent = p.textContent.replace(' + $35.00', '');
                priceAdjusted = false;
            }
        });
    }
});